import { render } from "./topOffices.vue?vue&type=template&id=1b55e5df"
import script from "./topOffices.vue?vue&type=script&lang=js"
export * from "./topOffices.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__